var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonMini buttonMini--circle38 drawingHeaderUI__clear",class:{'button--disable': !_vm.savable},on:{"click":_vm.clearCanvas}},[_c('img',{attrs:{"src":require("@/assets/header/trash.svg"),"width":"16","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }